// @flow
import type {UnitEnum} from '../util/enums';

export type Config = {|
    API_URL: string,
    EVENTS_URL: ?string,
    FEEDBACK_URL: string,
    REQUIRE_ACCESS_TOKEN: boolean,
    ACCESS_TOKEN: ?string,
    API_KEY: ?string,
    API_TOKEN: ?string,
    EXT_ACCOUNT_ID: ?string,
    TID_TOKEN: ?string,
    MAX_PARALLEL_IMAGE_REQUESTS: number,
    UNIT: ?UnitEnum,
|};

const config: Config = {
    API_URL: '',
    EVENTS_URL: '',
    FEEDBACK_URL: '',
    REQUIRE_ACCESS_TOKEN: true,
    ACCESS_TOKEN: null,
    API_KEY: null,
    API_TOKEN: null,
    EXT_ACCOUNT_ID: null,
    TID_TOKEN:null,
    MAX_PARALLEL_IMAGE_REQUESTS: 16,
    UNIT: null,
};

export default config;
